// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2mCpB","detailsBorder":"styles_detailsBorder__2IBop"};